var _circle, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAccount = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.0582,
    cy: 11.3043,
    r: 6.55433,
    stroke: "#768692",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.117 24.4521V27.25H7.41699V24.4521C7.41699 23.8796 7.66167 23.3602 8.1028 22.8741C8.55022 22.3811 9.17136 21.9567 9.83444 21.6067C10.4922 21.2596 11.1566 21.0037 11.6605 20.8342C11.8593 20.7673 12.0313 20.7145 12.1657 20.6753C12.3554 20.7911 12.6232 20.9352 12.9705 21.077C13.6943 21.3724 14.7555 21.6543 16.1626 21.6543C17.5698 21.6543 18.631 21.3724 19.3547 21.077C19.7045 20.9342 19.9736 20.7891 20.1636 20.6728C20.3057 20.7126 20.4904 20.7671 20.7051 20.8367C21.2293 21.0068 21.9205 21.2634 22.605 21.6118C23.2954 21.9631 23.9421 22.3893 24.4078 22.8841C24.8674 23.3725 25.117 23.8889 25.117 24.4521Z",
    stroke: "#768692",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAccount, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Account.7cae85d9.svg";
export { ForwardRef as ReactComponent };